import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "op-screen mx-auto flex max-w-3xl flex-col gap-10 px-6 pt-4 pb-12" };
import { Alert } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorView',
    setup(__props) {
        // Intentionally stateless. Renders a generic message only — never echoes the
        // token or any contact identity (no contact-existence leak). Mirrors the
        // EmailPreferencesView error state (OPAL Alert in the op-screen container).
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                _createVNode(_unref(Alert), {
                    color: "danger",
                    heading: _ctx.$t('error.heading'),
                    message: _ctx.$t('error.body')
                }, null, 8 /* PROPS */, ["heading", "message"])
            ]));
        };
    }
});
